import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import "bootstrap/dist/css/bootstrap.min.css";
import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
	apiKey: "AIzaSyBw-YvDN92lsCJKaZYwOg1GqFxjoYxdlic",
	authDomain: "dc-stores-bc1a4.firebaseapp.com",
	projectId: "dc-stores-bc1a4",
	storageBucket: "dc-stores-bc1a4.appspot.com",
	messagingSenderId: "925935989253",
	appId: "1:925935989253:web:eb968f6d39d98a48a1226c",
	measurementId: "G-67GK5N0D9E",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const storage = getStorage(app);
export const db = getFirestore(app);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
	<React.StrictMode>
		<App />
	</React.StrictMode>
);
